import zsmLayout from '@/zsm-layout'

const complaintsRouter = {
  path: '/complaints',
  name: 'complaints',
  redirect: '/complaints/index',
  component: () => import('@/view/complaints/content'),
  children: [
    {
      path: '/complaints',
      component: zsmLayout,
      name: 'complaints',
      redirect: '/complaints/index',
      children: [
        // {  //移到统计js里
        //   path: '/complaints/index',
        //   component: () => import('@/view/complaints/index'),
        //   name: 'complaintsStatistics'
        // },
        {
          path: '/complaints/detail',
          component: () => import('@/view/complaints/detail'),
          name: 'complaintsDetail'
        }
      ]
    },
    {
      path: '/complaints/agreement',
      component: () => import('@/view/complaints/agreement'),
      name: 'agreement'
    }
  ]
}

export default complaintsRouter
